import { stratify } from "d3-hierarchy";
import { tsv } from "d3-fetch";
import React from "react";
import { useRecoilValue, selector, atom, useRecoilState } from "recoil";
import CheckboxTree from "react-checkbox-tree";
import { syncEffect } from "recoil-sync";
import { array, string } from "@recoiljs/refine";

const availableCategoriesState = selector({
  key: "availableCategoriesState",
  get: async () => {
    const categoriesObj = await tsv(
      `${
        process.env.NODE_ENV === "development" ? process.env.PUBLIC_URL : ""
      }/Foursquare_to_NAICS_and_SIC.tsv`
    );

    const catogoriesWithIdAndParent = categoriesObj.map((category) => {
      const idArr = category.foursquare_category_label.split(" > ");
      const id = idArr[idArr.length - 1];
      const parentId = idArr[idArr.length - 2] || "root";
      return {
        ...category,
        id,
        parentId,
        value: category.foursquare_category_id,
        label: id,
      };
    });
    catogoriesWithIdAndParent.unshift({
      id: "root",
      parent: null,
      label: "root",
      value: "root",
    });

    const categoriesTree = stratify()(catogoriesWithIdAndParent);
    categoriesTree.descendants().forEach((d) => {
      d.label = d.data.label;
      d.value = d.data.value;
    });
    return categoriesTree;
  },
});

export const checkedCategoriesState = atom({
  key: "checkedCategoriesState",
  default: [],
  effects: [syncEffect({ refine: array(string()) })],
});

const openCategoriesState = atom({
  key: "openCategoriesState",
  default: [],
  effects: [syncEffect({ refine: array(string()) })],
});

const CategoryControl = () => {
  const availableCategories = useRecoilValue(availableCategoriesState);
  const [checked, setChecked] = useRecoilState(checkedCategoriesState);
  const [open, setOpen] = useRecoilState(openCategoriesState);

  return (
    <div
      style={{
        backgroundColor: "white",
        position: "absolute",
        right: 10,
        top: 20,
        height: "300px",
        overflow: "scroll",
      }}
    >
      <CheckboxTree
        nodes={availableCategories.children}
        checked={checked}
        expanded={open}
        checkModel="leaf"
        onCheck={(c, i) => setChecked(c)}
        onExpand={(o) => setOpen(o)}
        nativeCheckboxes={true}
        showNodeIcon={false}
        icons={{
          halfCheck: "✓",
          expandClose: "►",
          expandOpen: "▼",
          expandAll: "s",
          collapseAll: "h",
        }}
      />
    </div>
  );
};

export default CategoryControl;
